export default __webpack_public_path__ + "static/media/hampton.851771a2.jpg";